import type { SettingsMessages } from '../types';

const messages: SettingsMessages = {
  'app.settings.hasNoSetting': '未设置',
} as const;

export default messages;
